var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonStories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -2177.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Stories",
    transform: "translate(1206.000000, 2177.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,23.086 C13.239,23.086 11,20.838 11,18.064 C11,15.29 13.239,13.041 16,13.041 C18.762,13.041 21,15.29 21,18.064 C21,20.838 18.762,23.086 16,23.086 L16,23.086 Z M16,10.027 L0,4 L0,24.012 C0,25.268 0.776,26.393 1.947,26.833 L7.698,29 C8.785,26.688 11.03,25.096 13.632,25.096 L18.368,25.096 C20.97,25.096 23.216,26.688 24.302,29 L30.054,26.833 C31.225,26.393 32,25.268 32,24.012 L32,4 L16,10.027 Z",
    id: 198
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonStories);
export default __webpack_public_path__ + "static/media/common-stories.9f5b3593.svg";
export { ForwardRef as ReactComponent };